module.exports = __webpack_public_path__ + "static/media/MerchantIcon.856998bb.svg";